import axios from 'axios';
import Cookie from "js-cookie";
import AppStore from "@/store";
import {baseUrlByArchiveModeVersion} from "@/shared/archive-mode-utils";

export const BASE_API = baseUrlByArchiveModeVersion();
export const BASE_API_UPLOAD = process.env.VUE_APP_API_UPLOAD_URL;
console.log('API_URL:', BASE_API);

const http = axios.create({
  baseURL: BASE_API
});
http.interceptors.request.use(function (config) {
  const token = Cookie.get('x_token_' + process.env.VUE_APP_NAME);
  if (token != null && token.length > 0) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, function (err) {
  return Promise.reject(err);
});
http.interceptors.response.use((response) => {
  // console.log(response);
  return response;
}, (error) => {
  console.log("SERVER ERROR ")
  if (error && error.response && error.response.status && error.response.status === 401) {
    // console.log('unauthorized... will be redirected to login');
    // window.location = process.env.VUE_APP_WEB_URL + "login";
    AppStore.dispatch("logOut")
  }
  return Promise.reject(error);
});

export default http;
